export const LOAD_STUDENT_DETAILS = "LOAD_STUDENT_DETAILS";
export const REMOVE_STUDENT_DETAILS = "REMOVE_STUDENT_DETAILS";
